export enum TransactionType {
    ALL = 'all',
    INCOME = 'income',
    OUTCOME = 'outcome'
}
